import { useRef, useState } from 'react';
import { InView } from 'react-intersection-observer';
import loader from '../../../assets/img/loader.gif';

import styles from './ExhibitionImage.module.scss';
import { Link } from 'react-router-dom';
import useMobileDetect from 'use-mobile-detect-hook';

const ExhibitionImage = ({ url, author, name, id, price, blur }) => {
  const detectMobile = useMobileDetect();
  const isMobile = detectMobile.isMobile();
  const [isLoadImage, setIsLoad] = useState(false);
  const imageWidthRef = useRef();

  return (
    <InView threshold={0} triggerOnce={true}>
      {({ inView, ref, entry }) => (
        <div ref={ref}>
          <div data-status={inView ? 'show' : 'hide'} className={styles.picture_wrapper} >
            <Link to={'/gallery/profile/' + id}>
              <div>
                <img
                  src={isLoadImage ? 'https://place.industry.art' + url : loader}
                  alt={author}
                  style={isMobile ? { maxWidth: '100%' } : { maxWidth: '100%' }}
                  ref={imageWidthRef}
                  onLoad={() => setIsLoad(true)}
                  className={[styles.image, blur && styles.blur].join(' ')}
                />
                <img
                  src={isLoadImage ? 'https://place.industry.art' + url : loader}
                  alt={author}
                  style={isMobile ? { maxWidth: '100%' } : { maxWidth: '100%' }}
                  ref={imageWidthRef}
                  onLoad={() => setIsLoad(true)}
                  className={styles.fakeImage}
                />
              </div>
            </Link>
          </div>
          {isLoadImage && (
            <div className={styles.picture_info}>
              <p>{author}</p>
              <p>{name}</p>
              <p className={styles.price}>{price.slice(0, -3).replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1 ')} ₽</p>
            </div>
          )}
        </div>
      )}
    </InView>
  );
};

export default ExhibitionImage;
